<template>
    <div>
  
      <!-- :ref="el=>assignRef(el,index)"
      title1="kg"
      title2="%"
      :color1="getRandomColor(0)" 
      :color2="getRandomColor(1)"
      :series="getSeries(trainingItem)" -->
      <v-carousel :show-arrows="false">
        <v-carousel-item
          v-for="(item,i) in chartValue"
          :key="i">
        <v-card>
                 <LineChart
                 ref="chartRef"
              :data="item.data"
              :categories="item.categories"
              :legend="item.name"
            ></LineChart>
      
        </v-card>

    </v-carousel-item>
      </v-carousel>
 
  
      <div
      style="padding-top:40px"
        v-for="item in items"
        :key="item.id"
      >
        <DiaryItem
          :item="item"
          @click="handleClick(item)"
        >
        </DiaryItem>
      </div>
      <DiarySummary
        v-model="diarySummaryDialog"
        :record="currentRecord"
        :inBodyRecordList="inBodyRecordList"
        @prev="handlePrev"
        @next="handleNext"
      ></DiarySummary>
      <v-dialog
        v-model="bodyPartDialog"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="bodyPartDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Body Part Exercised</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container>
            <!-- <vue-apex-charts
              type="line"
              height="400"
              :options="chartOptions"
              :series="series"
            /> -->
            <!-- <LineChart
              :data="data"
              :categories="categories"
              legend="Body Part"
            ></LineChart> -->
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </template>
  <script setup>
  import VueApexCharts from 'vue-apexcharts'
  import { ref, nextTick, onMounted, computed } from 'vue'
  import themeConfig from '@themeConfig'
  import DiaryItem from './InBodyRecord/DiaryItem.vue'
  import LineChart from '@/components/Chart/LineChart.vue'
  import { fetchList } from '@/api/InBodyRecord'
  import DiarySummary from './InBodyRecord/DiarySummary.vue'
//   import TwoLineChart from '@/components/Chart/TwoLineChart.vue'
 
  import moment from '@/utils/moment'
  
  
  
  const diarySummaryDialog = ref(false)
  
  const data = ref([280])
  const categories = ref([
  ])
  
  const seriesValue = ref([
  ])
  
  
  const bodyPartDialog = ref(false)
  
  const chartRef = ref(null)

  const chartValue = ref([])
  
  let currentInBodyList = {}
  const items = ref([
  ])
  const defaultRecord = {
    userRecordID: 0,
    courseDate: '0001-01-01T00:00:00.000Z',
    courseDay: 0,
    workoutTypeID: 0,
    workoutIntensity: 0,
    dailyEvaluation: '',
    hourSelptLastNight: 0,
    moodID: 2,
    appetiteID: 0,
    energyID: 0,
    bodyWeight: 0,
    caloriesExpended: 0,
    trainingItems: [
    ],
    trainingAerobicItems: [],
    id: 0,
  
  
    testDateTime : '19700101000000',
  
    weightControl : 0 ,
    bfmControl : 0 ,
    ffmControl : 0 ,
    inBodyScore : 0 ,
    targetWeight : 0 ,
  
  
    weight : 0,
    lowerLimitWeightNormalRange: 0,
    upperLimitWeightNormalRange: 0,
  
    tbw : 0 ,
    lowerLimitTBWNormalRange : 0 ,
    upperLimitTBWNormalRange : 0 , 
  
    protein : 0 , 
    lowerLimitProteinNormalRange : 0 ,
    upperLimitProteinNormalRange : 0 ,
    
    minerals : 0 ,
    lowerLimitMineralsNormalRange : 0,
   upperLimitMineralsNormalRange : 0,
  
    bfm : 0 ,
    lowerLimitBFMNormalRange : 0,
    upperLimitBFMNormalRange : 0,
    
    smm:0,
    bmi:0,
    pbf:0,
  
    ffmOfRightArm:  0,
    ffmPercentOfRightArm: 0,
    ffmOfLeftArm:  0,
    ffmPercentOfLeftArm:  0,
    ffmOfTrunk:  0,
    ffmPercentOfTrunk:  0,
    ffmOfRightLeg: 0,
    ffmPercentOfRightLeg:  0,
    ffmOfLeftLeg: 0,
    ffmPercentOfLeftLeg:  0,
  
  
    bfmOfRightArm:  0,
    bfmPercentOfRightArm:  0,
    bfmOfLeftArm:  0,
    bfmPercentOfLeftArm: 0,
    bfmOfTrunk:  0,
    bfmPercentOfTrunk:  0,
    bfmOfRightLeg: 0,
    bfmPercentOfRightLeg:  0,
    bfmOfLeftLeg: 0,
    bfmPercentOfLeftLeg:  0 ,
  
    bmr : 0 ,
    lowerLimitBMRNormalRange: 0,
    upperLimitBMRNormalRange: 0,
    whr: 0,
    lowerLimitWHRNormalRange: 0,
    upperLimitWHRNormalRange: 0,
    vfl:0 , 
    obesityDegree: 0,
    lowerLimitObesityDegreeNormalRange: 0,
    upperLimitObesityDegreeNormalRange:0,
  
    kHz20RAImpedance:  0,
    kHz20LAImpedance:  0,
    kHz20TRImpedance:  0,
    kHz20RLImpedance:  0,
    kHz20LLImpedance:  0,
    kHz100RAImpedance:  0,
    kHz100LAImpedance:  0,
    kHz100TRImpedance:  0,
    kHz100RLImpedance:  0,
    kHz100LLImpedance:  0,
  
    
  
  }
  const currentRecord = ref({
    ...defaultRecord,
  })
  
   
  const inBodyRecordList = ref([])
  
  function handleClick(item) {
    console.log('handleClickitem',item)
    console.log('currentInBodyList',currentInBodyList)
    currentRecord.value = item
    inBodyRecordList.value = currentInBodyList
  // console.log('inBodyRecordListasd',inBodyRecordList.value)
    // bodyPartDialog.value = true
    diarySummaryDialog.value = true
  }
  
  const $themeColors = themeConfig.themes.light
  
  onMounted(() => {
    fetchList({
      page: 0,
      limit: 0,
      OrderBy  : "testDateTime",
      OrderDesc  : true
    }).then(res => {
      console.log('res', res)
      const inBodyItems = res.data.items
       currentInBodyList =  res.data.items

      items.value = []


      var yValueForWeight = []
      var yValueForSMM= []
      var yValueForPBF= []
      var xValueForDate = []


      for (let index = 0; index < inBodyItems.length; index += 1) {
        const  Item = inBodyItems[index]
        items.value.push(Item)
   
        // categories.value.push(moment(Item.testDateTime, 'YYYYMMDDHHmmss').format('DD MMM'))

        xValueForDate.push(moment(Item.testDateTime, 'YYYYMMDDHHmmss').format('DD MMM'))
   
         yValueForWeight.push(Item.weight)
         yValueForSMM.push(Item.smm)
         yValueForPBF.push(Item.pbf)
      }

      const seriesA = {  name: 'Weight(kg)'   , data : yValueForWeight  , categories : xValueForDate  }
      const seriesB = { name: 'SMM(kg)'      ,   data : yValueForSMM  ,  categories : xValueForDate   }
      const seriesC = {  name: 'PBF(%)'      , data : yValueForPBF  , categories : xValueForDate }
      chartValue.value.push(seriesA)
      chartValue.value.push(seriesB)
      chartValue.value.push(seriesC)

 

     
    //         chartRef.value.refresh()
    })
  })
  
  function handlePrev(courseDate) {
    console.log('handlePrev', courseDate)
    if (items.value && items.value.length > 0) {
      const index = items.value.findIndex(record => record.testDateTime === courseDate)
  
      const item = items.value[index]
      console.log('index', index)
      console.log('items', items)
      if (index >= 0 && index < items.value.length - 1) {
        const prevItem = items.value[index + 1]
        currentRecord.value = prevItem
        console.log('prev item', index, prevItem)
      }
    }
  }
  
  function handleNext(courseDate) {
    console.log('handleNext', courseDate)
    if (items.value && items.value.length > 0) {
      const index = items.value.findIndex(record => record.testDateTime === courseDate)
      const item = items.value[index]
      if (index > 0) {
        const nextItem = items.value[index - 1]
        console.log('prev item', index, nextItem)
        currentRecord.value = nextItem
      }
    }
  }
  
  function getRandomColor(index) {
    const colors = [
      '#2D78F0',
      '#DA0063',
      '#2D78F0',
      '#96D45A',
      '#DA0063',
      '#F24726',
      '#FF6347',
      '#48D1CC',
    ]
  
    return colors[index]
  }
  
  </script>
  <style scoped>
  </style>
  